module.exports = __webpack_public_path__ + "img/uz.ca892343.svg";